import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconLoading({ fill = "#3A80D1", size = 18, ...props }: SvgIconProps) {
  return (
    <SVGIcon width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="9" cy="9" r="7.5" stroke="#E5E5E5" strokeWidth="3" />
      <path
        className="segment"
        d="M9 0C10.1819 1.4094e-08 11.3522 0.232792 12.4442 0.685084C13.5361 1.13738 14.5282 1.80031 15.364 2.63604C16.1997 3.47177 16.8626 4.46392 17.3149 5.55585C17.7672 6.64778 18 7.8181 18 9L14.9994 9C14.9994 8.21215 14.8442 7.43201 14.5427 6.70413C14.2412 5.97625 13.7993 5.31488 13.2422 4.75778C12.6851 4.20069 12.0238 3.75878 11.2959 3.45728C10.568 3.15578 9.78785 3.0006 9 3.0006L9 0Z"
        fill={fill}
      />
    </SVGIcon>
  );
}
